import React from "react";
import "./ServicesSection.css";
import YoutubeVideo from "../common/YoutubeVideo";

const ServicesSection = () => {
  return (
    <section className="section" id="services">
      <div className="container">
        <h2 className="section-title">Services & Productions</h2>
        <div className="services-content">
          <div>
            <ul className="services-list">
              <li>Film Song recording, mixing and mastering</li>
              <li>Film Score arrangement and recording</li>
              <li>Film sound design and Foley</li>
              <li>Film Mixing Services</li>
              <li>ADR</li>
              <li>Drama OST recording, mixing and mastering</li>
              <li>Corporate sound design</li>
              <li>Restoration and archiving</li>
              <li>Technical and media array of events</li>
              <li>Live orchestra and musical band performance</li>
            </ul>
          </div>
          <div className="featured-production">
            <YoutubeVideo videoId="8q6Yuct9djY" />
            <div style={{ padding: "1.5rem" }}>
              <h3>Featured Production</h3>
              <p>Watch our latest project showcase and see our studio capabilities in action.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
